"use client";

import { LanguageContext } from "@/context/languageContext";
import { useContext, useEffect } from "react";
import Splash from "../Splash";
import ModuleRepeater from "./ModuleRepeater";
import Featured from "../Featured";
import Introduction from "@/components/Introduction";
import { FeaturedComponent } from "@/types/modules";
import { OurStoryPageQuery } from "@/types/wordpressQueries";
import { useLanguageUrl } from "@/context/languageURLContext";

interface OurStoryComponentProps {
  data: OurStoryPageQuery;
}

export default function OurStoryComponent({ data }: OurStoryComponentProps) {
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(data.page.translations[0].uri);
  }, [data.page.translations, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor: data.page.featured.backgroundColor,
    title: data.page.featured.title,
    custom: data.page.featured.custom,
  };

  return (
    <>
      {data.page.slider && data.page.slider.slider && (
        <Splash slider={data.page.slider.slider} />
      )}
      <Introduction
        title={data.page.introduction.title}
        content={data.page.introduction.content}
      />
      <ModuleRepeater modules={data.page.optionsOurStory.modules} />
      <Featured featured={featured} />
    </>
  );
}
